import { createAction, props } from '@ngrx/store';
import { FilterDocumentsType } from '../../../modules/documentos/services/documents.service';

export const documentFiltersActionType = '[Documents Module] setFilters';

export const documentFiltersAction = createAction(
	documentFiltersActionType,
	props<FilterDocumentsType>()
);